import { render, staticRenderFns } from "./PrivacyStatement.vue?vue&type=template&id=4dff21fe"
import script from "./PrivacyStatement.vue?vue&type=script&lang=js"
export * from "./PrivacyStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports